import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class FAQsModel extends BaseModel {

    constructor() {
        super({
                name: "faqs",
                tableName: 'faqs',
                label: "FAQs",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Title',
                    width: 20,
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                },
                short_description: {
                    name: 'short_description',
                    type: "Number",
                    label: 'Short description',
                    width: 10,
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                },
                ordinal: {
                    name: 'ordinal',
                    type: "Number",
                    label: 'Order',
                    width: 10,
                    class: 'left',
                },

                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: 'left',
                    width : 8,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at : {
                    name: 'updated_at',
                    type: "String",
                    label: 'Updated date',
                    width: 8,
                    class:"left",
                },
                detail_get: {
                    refs:  ' updated_by_key { id fullname }  ',
                    display: false
                },
                detail_get1: {
                    refs:  ' description  ',
                    display: false
                },
            })
    }

}